import { Component, ElementRef, ViewChild } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Api } from "src/app/services/api";
import { Globals } from "src/app/services/globals";
import { Guid, partnerReclaimRefundAllowed, removePadding } from "../../../../../../../common/common-helpers/utility";
import { availableAdminSkuInfoByPosterType, availableSkuInfoByPosterType, clothesSKUsByCategory, productNamesBySKU } from "../../../../../../../common/common-helpers/sku";
import { PosterType } from "../../../../../../../common/common-types/poster-type";
import { ClothesCategory } from "../../../../../../../common/common-types/clothes";
import {
    IContactInfo,
    IPosterOrder,
    ReclaimBlame,
} from "../../../../../../../common/common-interfaces/poster-order";
import { countryCodesUpperCase } from "../../../../../../../common/common-types/country";

@Component({
    selector: "create-order",
    templateUrl: "./create-order.component.html",
    styleUrls: ["./create-order.component.scss"],
    standalone: false
})
export class CreateOrderComponent {
    availableCountryCodes = countryCodesUpperCase;
    productNamesBySKU = productNamesBySKU;
    newOrder: {
        items: {
            identifier: string;
            type: PosterType;
            sku: string;
            location?: 'FRONT' | 'BACK'; // For clothes
            quantity: number;
        }[];
        shippingInfo: IContactInfo;
        isReclaim?: boolean;
        reclaimOrderId?: string;
        reclaimOrderNumber?: string;
        reclaimBlame?: ReclaimBlame;
        reclaimDescription?: string;
        partnerCreditsToRefund?: number;
        cancelReclaimedOrder?: boolean;
        sendShippingDispatchEmail?: boolean;
    } = {
            items: [],
            shippingInfo: {
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                address1: "",
                city: "",
                zipCode: "",
                country: "SE",
            },
            reclaimBlame: "PARTNER",
            cancelReclaimedOrder: false,
            sendShippingDispatchEmail: false,
        };

    creatingOrder: boolean = false;
    availableSkuInfoByPosterType = availableSkuInfoByPosterType;
    clothesSKUsByCategory = clothesSKUsByCategory;

    selectedClothesCategory: { [orderItemIdentifier: string]: ClothesCategory } = {};

    reclaimedOrder: IPosterOrder;

    private paramsSubscription?: Subscription;
    constructor(
        private api: Api,
        private router: Router,
        private route: ActivatedRoute,
        public globals: Globals,
        private sanitizer: DomSanitizer,
    ) {
    }

    async ngOnInit() {
        (window as any).productNamesBySKU = productNamesBySKU;
        if (this.globals.currentUser.role == 'ACE') {
            for (let type in availableAdminSkuInfoByPosterType) {
                if (!this.availableSkuInfoByPosterType[type])
                    this.availableSkuInfoByPosterType[type] = [];

                for (let skuInfo of availableAdminSkuInfoByPosterType[type]) {
                    if (!this.availableSkuInfoByPosterType[type].some(x => x.sku == skuInfo.sku))
                        this.availableSkuInfoByPosterType[type].push(skuInfo);
                }
            }


        }


        this.paramsSubscription = this.route.params.subscribe(
            async (params: any) => {
                if (params.originalOrderId) {
                    this.reclaimedOrder = await this.api.store().get<any>(
                        `/poster-orders/${params.originalOrderId}`,
                    );
                    this.newOrder.shippingInfo = this.reclaimedOrder.shippingInfo;
                    this.newOrder.isReclaim = true;
                    this.newOrder.reclaimOrderNumber = this.reclaimedOrder.orderNumber;
                    this.newOrder.reclaimOrderId = this.reclaimedOrder._id;
                    this.newOrder.reclaimBlame = "PARTNER";

                    this.newOrder.items = this.reclaimedOrder.items.map((item) => {
                        let sku = item.sku;
                        if (item.thirdParty && item.thirdParty.exakta && item.thirdParty.exakta.tShirtDetails) {
                            sku = item.thirdParty.exakta.tShirtDetails.partnerSku;
                        }

                        let type: any = item.posterType;

                        if (item.isStockItem)
                            type = 'STOCK_ITEM';

                        return {
                            identifier: item.identifier,
                            type: type,
                            sku: sku,
                            quantity: item.quantity,
                        };
                    });

                    if (this.globals.storeSettings.type == 'partner') {
                        await this.reclaimBlameChanged();
                    }

                }
                else {

                }
            },
        );

        await this.addItem();
    }

    async createOrder() {
        this.creatingOrder = true;
        try {
            let result = await this.api.store().post<any>(
                "/poster-orders/create",
                this.newOrder,
            );
            if (result.succeeded) {
                this.router.navigate([this.globals.panelUrl("/poster-orders")]);
            }
        } catch (e) {
            console.error(e);
        }
        this.creatingOrder = false;
    }

    async addItem() {
        this.newOrder.items.push({
            identifier: Guid(),
            type: "POSTER",
            location: 'FRONT', // Default location for clothes
            sku: this.availableSkuInfoByPosterType["POSTER"][0].sku,
            quantity: 1,
        });
    }

    async removeItem(item) {
        this.newOrder.items.splice(this.newOrder.items.indexOf(item), 1);
    }

    async reclaimBlameChanged() {

        // ACE USER
        if (this.globals.userIsAce()) {
            if (!this.reclaimedOrder.creditTransactionId) {
                this.newOrder.partnerCreditsToRefund = 0;
                return;
            }

            if (partnerReclaimRefundAllowed(this.newOrder.reclaimBlame) && this.reclaimedOrder) {
                if (this.reclaimedOrder.processingFee) {
                    this.newOrder.partnerCreditsToRefund = this.reclaimedOrder.processingFee.total;
                }
                else {
                    this.newOrder.partnerCreditsToRefund = 0;
                }


            }
            else {
                this.newOrder.partnerCreditsToRefund = 0;
            }
        }

        // PARTNER USER
        else {
            this.newOrder.partnerCreditsToRefund = 0;
        }


    }

    ngOnDestroy(): void {
        if(this.paramsSubscription)
        (this.paramsSubscription as Subscription).unsubscribe();

    }
}
